export default __webpack_public_path__ + "static/media/face_2.b85dc7b8.png";